import React, { useEffect, useState } from 'react';
import styles from './BonusModal.module.scss';
import Modal from '../Modal/Modal';
import { TelegramSticker } from '@/components/TelegramSticker';
import { ReactComponent as StarIcon } from '@/assets/Icons/star.svg';
import { useNotificationStore } from '@/store/NotificationStore';
import useBonusStore from '@/store/BonusStore';
import { getBonus } from '@/api/modules/Login/login';
import useBalanceStore from '@/store/BalanceStore';

interface WalletModalProps {
  open: boolean;
  onClose: () => void;
  bonusAmount: number;
}

const BonusModal: React.FC<WalletModalProps> = ({
  open,
  onClose,
  bonusAmount,
}) => {
  const tg = window?.Telegram?.WebApp;
  const setNotification = useNotificationStore(
    (state) => state.setNotification,
  );
  const setBonus = useBonusStore((state) => state.setBonus);
  const balance = useBalanceStore((state) => state.balance);
  const setBalance = useBalanceStore((state) => state.setBalance);
  const [loading, setLoading] = useState(false);

  const handleBonus = async () => {
    if (loading) return; // защита от повторного клика
    setLoading(true);
    try {
      const result = await getBonus();

      if (result === 'blocked') {
        setNotification({
          type: 'Error',
          message: 'Необходимо разрешить отправку сообщений.',
        });
        return;
      }
      setNotification({
        type: 'Success',
        message: 'Бонус получен',
      });
      setBonus(false);
      window.dispatchEvent(new Event('bonus-received'));
      onClose();
    } catch (e) {
      setNotification({
        type: 'Error',
        message: 'Ошибка при получении бонуса',
      });
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  return (
    <Modal open={open} onClose={onClose} noCross={true}>
      <div className={styles.walletModal}>
        <div className={styles.stickerWrapper}>
          <TelegramSticker
            tgsUrl="./frogMoney.tgs"
            style={{ width: 160, height: 160 }}
            loop={false}
            autoplay={true}
          />
        </div>
        <h2 className={styles.title}>Приветственный Бонус</h2>
        <p className={styles.description}>Начни своё путешествие с награды!</p>
        <div className={styles.balanceInfo}>
          <div className={styles.balanceItem}>
            <span className={styles.value}>
              {' '}
              {bonusAmount} <StarIcon />{' '}
            </span>
          </div>
        </div>
        <button
          disabled={loading}
          onClick={handleBonus}
          className={styles.withdrawButton}
        >
          Забрать награду
        </button>
      </div>
    </Modal>
  );
};

export default BonusModal;
